export enum PeriodoBoletim {
	MENSAL = 'MENSAL',
	ANUAL = 'ANUAL',
	AMBOS = 'AMBOS',
}
